<template>
    <div id="fxh">
        <div class="top_part">
            <img class="top-back-img" src="@/assets/down-ad/fxh/1.png" alt="">
            <div class="button_box">
                <button @click="down">点击下载金果子APP</button>
            </div>
        </div>
        <div class="middle-part">
            <img src="@/assets/down-ad/fxh/2.png" alt="">
        </div>
        <div class="bottom-part">
            <img src="@/assets/down-ad/fxh/3.png" alt="">
        </div>
        <div id="mask" v-show="maskViewShow" @click="maskViewShow = false">
            <span class="mask-tip">请在浏览器中打开</span>
            <img src="@/assets/down/tip_arrow.png"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProDownload01',
    data() {
        return {
            maskViewShow: false,
            iosUrl: '',
            androidUrl: '',
        }
    },
    mounted() {
        this.getDownUrl();
    },
    watch: {
    },
    methods: {
        down() {
            const host = window.location.host
            // const host = 'https://misc.jgzpro.com'
            window.open('https://misc.jgzpro.com/platform-fxh-down?d=MjY5MjRfVDlQQVc1')
        }
    }
}
</script>

<style lang='less'>
#fxh {
	height: auto;
	width: 100vw;
	background: #111125;;
	// padding-top: 38px;
	background-size: 100% 100%;
	background-repeat: no-repeat;
    position: relative;
    img {
        pointer-events: none;
    }
    .top_part {
        width: 100vw;
        height: 1258px;
        position: relative;
        .top-back-img {
            position: absolute;
            left: 0;
            top: 0;
            width: 100vw;
        }
        .button_box {
            width: 100vw;
            position: absolute;
            top: 664px;
            left: 0;
        }
        button {
            height: 90px;
            width: 460px;
            outline: none;
            border: none;
            cursor: pointer;
            border-radius: 45px;
            background: linear-gradient(90deg,#ff7800 0%, #ffc000 100%);
            box-shadow: -5px 0px 0px 0px rgba(255,207,152,0.81);
            position: absolute;
            color: #ffffff;
            font-size: 32px;
            font-weight: bold;
            left: 145px;
        }
    }
    .middle-part {
        img {
            width: 100vw;
        }
    }
    .bottom-part {
        img {
            width: 100vw;
        }
    }
}
</style>
